import PropTypes from "prop-types";
import { Button, Grid2, Typography } from "@mui/material";
import { ArrowBack, Refresh } from "@mui/icons-material";
import { Image } from "mui-image";

import logo from "../assets/images/logo-black.png";

const ErrorFallback = ({ message = "Κάτι πήγε στραβά! Δοκιμάστε ξανά!", refetch = () => window.location.reload() }) => (
	<Grid2
		container
		direction="column"
		alignItems="center"
		sx={{
			position: "absolute",
			top: "50%",
			left: "50%",
			transform: "translate(-50%, -50%)",
		}}
	>
		<Grid2 item xs={12}>
			<Image src={logo} alt="Sefa" width="250px" />
		</Grid2>
		<Grid2 item xs={12} mt={2}>
			<Grid2 container direction="column" spacing={6}>
				<Grid2 item xs={12}>
					<Typography align="center" variant="h6">{message}</Typography>
				</Grid2>
				<Grid2 item xs={12}>
					<Grid2 container spacing={2} justifyContent="center">
						<Grid2 item>
							<Button size="small" startIcon={<ArrowBack />} variant="outlined" onClick={() => { window.location.href = "/"; }}>
								{"Πίσω"}
							</Button>
						</Grid2>
						{refetch && (
							<Grid2 item>
								<Button size="small" startIcon={<Refresh />} variant="contained" onClick={refetch}>
									{"Δοκιμάστε ξανά"}
								</Button>
							</Grid2>
						)}
					</Grid2>
				</Grid2>
			</Grid2>
		</Grid2>
	</Grid2>
);

ErrorFallback.propTypes = { message: PropTypes.string, refetch: PropTypes.func };

export default ErrorFallback;
